import { computed, onMounted } from 'vue';
import { useGoogleScriptStore } from 'src/stores/googleScript';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
/**
 * init google api
 * @returns {
 *  googleReady: if google is ready,
 *  gcalReady: if google calendar is ready
 * }
 */
const InitGoogleAppPlugin = () => {
    const $q = useQuasar();
    const gScriptStore = useGoogleScriptStore();
    const googleReady = computed({
        get: () => gScriptStore.googleReady,
        set: (newValue) => {
            gScriptStore.toggleGoogle(newValue);
        }
    });
    /**
     * When google client is loaded
     */
    function googleClientLoaded() {
        googleReady.value = true;
    }
    /**
     * Add google client script
     * to body and load
     */
    function loadGoogleClient() {
        window.clientLoaded = googleClientLoaded;
        const gsiScript = document.createElement('script');
        gsiScript.src = 'https://accounts.google.com/gsi/client';
        gsiScript.async = true;
        gsiScript.defer = true;
        gsiScript.id = 'google-gsi';
        if (window.nonce)
            gsiScript.setAttribute('nonce', window.nonce);
        gsiScript.addEventListener('load', () => {
            googleClientLoaded();
        }, { once: true });
        document.body.appendChild(gsiScript);
    }
    const gcalReady = computed({
        get: () => gScriptStore.gcalReady,
        set: (newValue) => {
            gScriptStore.toggleGCal(newValue);
        }
    });
    /**
     * When google calendar client is loaded
     */
    function gcalClientLoaded() {
        gcalReady.value = true;
    }
    /**
     * Add google calendar script
     * to body and load
     */
    function loadGcalClient() {
        window.gcalClientLoaded = gcalClientLoaded;
        const clientScript = document.createElement('script');
        clientScript.src = 'https://apis.google.com/js/api.js';
        clientScript.async = true;
        clientScript.defer = true;
        clientScript.id = 'google-client';
        if (window.nonce)
            clientScript.setAttribute('nonce', window.nonce);
        clientScript.addEventListener('load', () => {
            gcalClientLoaded();
        }, { once: true });
        document.body.appendChild(clientScript);
    }
    onMounted(() => {
        // load google scripts after mounted
        if ($q.platform.is.capacitor || (typeof window === 'undefined'))
            return;
        if (!googleReady.value) {
            loadGoogleClient();
        }
        if (!gcalReady.value) {
            loadGcalClient();
        }
    });
    return { googleReady, gcalReady };
};
export { InitGoogleAppPlugin };
